import { render, staticRenderFns } from "./TestItemPickWrong.vue?vue&type=template&id=218b1382&scoped=true&"
import script from "./TestItemPickWrong.vue?vue&type=script&lang=js&"
export * from "./TestItemPickWrong.vue?vue&type=script&lang=js&"
import style0 from "./TestItemPickWrong.vue?vue&type=style&index=0&id=218b1382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b1382",
  null
  
)

export default component.exports